import type { SchemaObject } from 'ajv';
import _ from 'lodash';
import type { Patch, PatchEntry } from './types';

function isPropertyType(schema: SchemaObject) {
  return (
    _.has(schema, 'properties') &&
    _.has(schema.properties, 'value') &&
    _.has(schema.properties, 'defaultValue') &&
    _.has(schema.properties, 'isRequired')
  );
}

function isQuantity(schema: SchemaObject) {
  return (
    _.has(schema, 'properties') &&
    _.has(schema.properties, 'unit') &&
    _.has(schema.properties, 'value')
  );
}

function unrefSchema(schema: SchemaObject, spec: SchemaObject) {
  return _.has(schema, '$ref') ? _.get(spec, schema.$ref.split('/').splice(1)) : schema;
}

const patchPropertyTypeSchema: Patch = (schema, _key, _parent, originalSpec) => {
  if (!isPropertyType(schema)) return;

  const valueSchema = schema.properties.value;
  const quantitySchema = unrefSchema(valueSchema, originalSpec);
  const isQty = isQuantity(quantitySchema);

  if (schema.properties.isRequired) {
    schema.if = { properties: { isRequired: { const: true } } };
    schema.then = { required: [...(schema.required || []), 'value'] };
  }

  const applyQuantityLogic = () => {
    const cloned = _.cloneDeep(quantitySchema);

    if (schema.properties.defaultValue) {
      schema.properties.defaultValue = { ...quantitySchema, nullable: true };
    }

    if (schema.properties.min) {
      cloned.properties.value.minimum = { $data: '2/min/value' };
    }
    if (schema.properties.max) {
      cloned.properties.value.maximum = { $data: '2/max/value' };
    }

    return cloned;
  };

  const applyNonQuantityLogic = () => {
    const tgt = schema.properties.value;
    if (schema.properties.min) tgt.minimum = { $data: '1/min' };
    if (schema.properties.max) tgt.maximum = { $data: '1/max' };
    return tgt;
  };

  schema.properties.value = isQty ? applyQuantityLogic() : applyNonQuantityLogic();

  // make always nullable
  schema.properties.value = {
    ...schema.properties.value,
    nullable: true,
  };
};

export const propertyTypePatchEntry: PatchEntry = {
  condition: isPropertyType,
  patch: patchPropertyTypeSchema,
};
